import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const ReleaseNotesOverview = lazy(() => import('./release-notes-overview/release-notes-overview.component'));

export function ReleaseNotesRoutes() {
    return (
        <Route path='release-notes'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <ReleaseNotesOverview />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
